// Option A: single component with optional subtitle handles both usage shapes with minimal prop count.

function scoreColor(score: number): string {
  if (score >= 80) return 'var(--color-accent)';
  if (score >= 60) return 'var(--color-accent-gold)';
  return 'var(--color-accent-red)';
}

interface ChartTooltipProps {
  active?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload?: any[];
  label?: string;
  subtitle?: string;
}

export function ChartTooltip({ active, payload, label, subtitle }: ChartTooltipProps) {
  if (!active || !payload?.length) return null;

  const hasSingleScoreEntry =
    payload.length === 1 && payload[0]?.dataKey === 'score';

  return (
    <div
      style={{
        background: 'var(--color-dark-card)',
        border: '1px solid var(--color-border-subtle)',
        borderRadius: '10px',
        padding: '10px 14px',
        boxShadow: 'var(--shadow-modal)',
        minWidth: '130px',
        fontSize: '12px',
      }}
    >
      <p style={{ color: 'var(--color-text-muted)', marginBottom: '6px' }}>{label}</p>

      {hasSingleScoreEntry ? (
        <>
          <p
            style={{
              color: scoreColor(payload[0].value as number),
              fontSize: '20px',
              fontWeight: 700,
              lineHeight: 1,
            }}
          >
            {Math.round(payload[0].value as number)}
            <span
              style={{
                fontSize: '11px',
                fontWeight: 400,
                marginLeft: '2px',
                color: 'var(--color-text-muted)',
              }}
            >
              / 100
            </span>
          </p>
          {(subtitle ?? payload[0]?.payload?.athleteName) && (
            <p
              style={{
                color: 'var(--color-text-secondary)',
                fontSize: '11px',
                marginTop: '4px',
              }}
            >
              {subtitle ?? payload[0].payload.athleteName}
            </p>
          )}
        </>
      ) : (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        payload.map((entry: any) => (
          <p
            key={entry.dataKey}
            style={{ color: entry.color, margin: '2px 0', fontWeight: 600 }}
          >
            {entry.name}: {Math.round(entry.value)}
          </p>
        ))
      )}
    </div>
  );
}

export default ChartTooltip;
